import React from 'react'

const DownArrowIcon = ({ color = '#B5B0A9', width, height }) => {
  return (
    <svg width={width || '18'} height={height || '17'} viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.82132 16.5644L0.82251 8.50549L2.25151 6.99512L8.15868 13.5127L7.70208 0.155701H9.94073L9.48396 13.5116L15.6338 6.99512L17.0628 8.50549L8.82132 16.5644Z' fill='#FF0E1D' />
    </svg>
  )
}

export default DownArrowIcon
